import moment from "moment";
import { parseLocalDate } from "./parseLocalDate";

/** Single date: Sep 26, 2026 */
export function formatDisplayDate(value) {
  const d =
    value instanceof Date ? value : parseLocalDate(value) || (value ? new Date(value) : null);
  if (!d || Number.isNaN(d.getTime())) return "";
  return moment(d).format("MMM DD, YYYY");
}

/** Pay period range: Sep 26, 2026 - Oct 09, 2026 */
export function formatPayPeriodRange(start, end) {
  if (!start || !end) return "—";
  const from = formatDisplayDate(start);
  const to = formatDisplayDate(end);
  if (!from || !to) return "—";
  return `${from} - ${to}`;
}
